import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FadeInOnScrollDirective } from '../../../directives/fade-in-on-scroll.directive';
import { eventInfo } from '../../../app.constants';
import { ShowOnMobileOrTabletDirective } from '../../../core/device/show-on-mobile-or-tablet.directive';
import { ShowOnDesktopDirective } from '../../../core/device/show-on-desktop.directive';

@Component({
  selector: 'app-hero',
  imports: [FadeInOnScrollDirective, ShowOnMobileOrTabletDirective, ShowOnDesktopDirective],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeroComponent {
  protected readonly szebitDateHu = eventInfo()['dateHu'];
}
